import PropTypes from "prop-types"
import React from "react"

const WhatHappensNextPanel = ({ copy }) => {
  const items = [
    { title: copy.whatHappensNextSign, body: copy.whatHappensNextSignBody },
    {
      title: copy.whatHappensNextConfirm,
      body: copy.whatHappensNextConfirmBody,
    },
    { title: copy.whatHappensNextPay, body: copy.whatHappensNextPayBody },
  ]

  return (
    <section className="rounded-lg border border-gray-300 px-4 py-6">
      <h4 className="mb-4 mt-0 font-semibold">{copy.whatHappensNextTitle}</h4>
      <ol className="m-0 flex list-none flex-col gap-4 p-0">
        {items.map(({ title, body }, index) => (
          <li key={title} className="flex gap-3">
            <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-yellow-100 text-sm font-semibold text-gray-900">
              {index + 1}
            </span>
            <div className="flex flex-col">
              <span className="font-semibold text-gray-900">{title}</span>
              <span className="text-gray-700">{body}</span>
            </div>
          </li>
        ))}
      </ol>
    </section>
  )
}

WhatHappensNextPanel.propTypes = {
  copy: PropTypes.shape({
    whatHappensNextConfirm: PropTypes.string,
    whatHappensNextConfirmBody: PropTypes.string,
    whatHappensNextPay: PropTypes.string,
    whatHappensNextPayBody: PropTypes.string,
    whatHappensNextSign: PropTypes.string,
    whatHappensNextSignBody: PropTypes.string,
    whatHappensNextTitle: PropTypes.string,
  }).isRequired,
}

export default WhatHappensNextPanel
